<div class="sidebar" [style.z-index]="sidebarIsOpened ? 1 : 0" [ngClass]="{'sidebar--web': environment.webBuild}">
	<div class="languages" *ngIf="!environment.webBuild">
		<h2 class="languages__title">{{ 'NAVIGATION.LANGUAGE' | translate }}</h2>
		<div class="languages__list">
			<div *ngFor="let language of languages" class="languages__item" (click)="setLanguage(language)" [ngClass]="{'languages__item--active': isActiveLanguage(language)}">{{ language }}</div>
		</div>
	</div>
	<div class="navigation">
		<div class="navigation__item">
			<a class="navigation__link navigation__link--with-icon" [routerLink]="'/sync'">{{ 'SYNC.TITLE' | translate }}<i class="fa fa-sync navigation__icon"></i></a>
		</div>
		<div class="navigation__item" *ngIf="lastUpdate">
			<span class="navigation__info">{{ 'SYNC.LAST_SYNC' | translate }}<br/>{{ 'SYNC.LAST_SYNC_DATETIME' | translate:lastUpdate }}</span>
		</div>
		<div class="navigation__seperator" *ngIf="!environment.webBuild"></div>
		<div class="navigation__item" *ngIf="!environment.webBuild">
			<a class="navigation__link" [routerLink]="'/portal/privacy'">{{ 'NAVIGATION.DATA_PROTECTION' | translate }}</a>
		</div>
		<div class="navigation__item" *ngIf="!environment.webBuild">
			<a class="navigation__link" [routerLink]="'/portal/imprint'">{{ 'NAVIGATION.IMPRINT' | translate }}</a>
		</div>
	</div>
</div>



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/sidebar/sidebar.component.html